import { StreamField } from 'components/staticpages/streamfield'
import styles from './headerheroblock.css'

type HeaderHeroBlockProps = {
  value: {
    background_image: string
    background_video: string
    content: Array<{
      title: string
      description: string
      video_url: string
      arranger_images: Array<number>
      steps: Array<{
        image: number
        description: string
      }>
    }>
    background_color?: string
  }
}

const HeaderHeroBlock = (props: HeaderHeroBlockProps): JSX.Element => {
  const {
    value: { background_image, background_video, content, background_color },
  } = props
  return (
    <div className={styles.wrapper} style={{ backgroundColor: background_color || 'black' }}>
      {background_video ? (
        <div>
          <video src={background_video} autoPlay loop width="100%" className={styles.videoBackground} />
          <div className={styles.headerOverlay}>
            <StreamField blocks={content} />
          </div>
        </div>
      ) : (
        <div
          className={styles.imageBackground}
          style={{
            backgroundImage: `url("/is/${background_image}/fill-1600x594/")`,
          }}
        >
          <div className={styles.headerOverlay}>
            <StreamField blocks={content} />
          </div>
        </div>
      )}
    </div>
  )
}

export default HeaderHeroBlock
